import {EventEmitter, Injectable} from '@angular/core';
import {AppService} from '../app/app.service';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class RequestsWebsocketService {

  webSocket: WebSocket;
  emitters: { [id: number]: EventEmitter<any> } = {};
  lastRequest = 1;
  lostConnection = false;

  constructor(public serverService: ApiService,
              public appService: AppService) {
    this.serverService = serverService;
    this.appService = appService;

    // this.connect();
  }

  async connect() {
    // try {
    //   this.webSocket = new WebSocket(this.serverService.requestsWebsocketUrl);
    //
    //   this.webSocket.onmessage = async (event) => {
    //     try {
    //       const response = JSON.parse(event.data);
    //       if (response.requestId !== undefined && !isNaN(response.requestId)) {
    //         await this.emitters[response.requestId].emit(response);
    //         setTimeout(() => {
    //           this.emitters[response.requestId] = undefined;
    //         }, 1000);
    //       } else {
    //       }
    //     } catch (e) {
    //
    //     }
    //   };
    // } catch (e) {
    //   setTimeout(async () => {
    //     await this.connect();
    //   }, 1000);
    // }
  }

  async sendWithCallback<T>(request: any) {
    // while (this.webSocket.readyState === this.webSocket.CONNECTING) {
    //   await this.delay(10);
    // }
    // request.requestId = this.lastRequest;
    // this.emitters[this.lastRequest] = new EventEmitter<any>();
    // this.webSocket.send(JSON.stringify(request));
    // this.lastRequest++;
    // return this.emitters[this.lastRequest - 1];
    return new Promise(resolve => undefined );
  }

  async sendWithPromise<T>(request: any): Promise<T> {
    return new Promise(resolve => undefined );
    // let done = false;
    // let requestResponse;
    // const eventEmitted = await this.sendWithCallback<T>(request);
    // eventEmitted.subscribe((response) => {
    //   done = true;
    //   requestResponse = response;
    // });
    // if (this.lostConnection && !['Ping', 'Changes', 'Realtime'].includes(request.route)) {
    //   eventEmitted.emit({success: false, error: 'Network error. Please check your internet connection.'});
    // }
    // while (!done) {
    //   await this.delay(10);
    // }
    // return requestResponse;
  }

  async delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
